import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={26.086}
    height={18.107}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20448 14193"
    {...props}
  >
    <defs>
      <style>
        {
          ".str0,.str1{stroke:#000;stroke-width:592.522}.str0{stroke-width:296.261}.str2{stroke:#1c1b17;stroke-width:225.751}.fil0,.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M17016 3101c-99 0-180 81-180 180s81 180 180 180 180-81 180-180-81-180-180-180zm0 476c-163 0-296-133-296-296s133-296 296-296 296 133 296 296-133 296-296 296zM6829 2068h6784l-729-1292H7558l-729 1292zm7029 284H6586c-51 0-98-27-123-70-26-44-26-98-1-142l890-1575c25-45 72-73 123-73h5492c51 0 98 28 123 73l882 1561c17 23 28 52 28 84 0 78-64 142-142 142zM10221 3679c-2780 0-5041 2262-5041 5041 0 2780 2261 5041 5041 5041s5041-2261 5041-5041-2261-5041-5041-5041zm0 10366c-2936 0-5325-2389-5325-5325s2389-5325 5325-5325 5325 2389 5325 5325-2389 5325-5325 5325z"
        className="fill stroke1"
        style={{
          strokeWidth: 592.522,
        }}
      />
      <path
        d="M853 2352c-232 0-421 189-421 421v10037c0 233 189 421 421 421h7083c22 0 43 5 63 15 695 342 1442 515 2222 515 779 0 1527-173 2222-515 20-10 41-15 63-15h7083c232 0 421-188 421-421V2773c0-232-189-421-422-421H853zm9368 11693c-812 0-1592-178-2318-530H853c-388 0-705-316-705-705V2773c0-389 317-705 705-705h18736c388 0 705 316 705 705v10037c0 389-317 705-706 705h-7049c-726 352-1506 530-2318 530z"
        className="fill stroke1"
        style={{
          strokeWidth: 592.522,
        }}
      />
      <path
        d="M663 11618h4692c-124-175-238-359-342-551H663v551zm4956 285H548c-64 0-116-64-116-142v-837c0-78 52-142 116-142h4528c39 0 76 25 97 66 152 291 330 565 529 813 32 41 42 102 24 155s-60 87-107 87z"
        className="fill stroke1"
        style={{
          strokeWidth: 592.522,
        }}
      />
      <path
        d="M15219 11618h4701v-551h-4359c-104 192-218 376-342 551zm4817 285h-5082c-47 0-89-34-107-87s-8-114 24-155c200-249 378-522 530-813 22-41 58-66 98-66h4537c64 0 116 64 116 142v837c0 78-52 142-116 142z"
        className="fill stroke1"
        style={{
          strokeWidth: 592.522,
        }}
      />
      <path
        d="M432 11375h5172c-464-806-708-1718-708-2655 0-1647 754-3183 2038-4189H432v6844zm5424 284H290c-78 0-142-64-142-142V4389c0-79 64-142 142-142h7084c63 0 118 41 136 101s-5 125-58 159c-1422 937-2272 2512-2272 4213 0 969 275 1909 796 2720 28 44 30 99 5 145s-73 74-125 74zM14838 11375h5172V4531h-6502c1284 1006 2038 2542 2038 4189 0 937-244 1849-708 2655zm5314 284h-5567c-51 0-100-28-124-74-25-46-23-101 5-145 521-811 796-1751 796-2720 0-1701-850-3276-2272-4213-53-34-77-99-59-159 19-60 74-101 137-101h7084c78 0 142 63 142 142v7128c0 78-64 142-142 142z"
        className="fill stroke1"
        style={{
          strokeWidth: 592.522,
        }}
      />
      <path
        d="M2179 113h2408c326 0 593 267 593 592v1363H1587V705c0-325 266-592 592-592zM17027 409h961c326 0 593 267 593 593v1053h-2147V1002c0-326 267-593 593-593z"
        className="fill stroke1"
        style={{
          strokeWidth: 225.751,
        }}
      />
      <circle cx={10221} cy={8945} r={3669} className="fil1 str2" />
    </g>
  </svg>
);
export default SvgComponent;
